import { MUTATE, MUTATE_ARRAY_INDEX, MUTATE_MULTIPLE } from '@/store/modules/mutation_types';
import { mutate, mutateArrayIndex, mutateMultiple } from '@/store/modules/mutations';

export default {
  [MUTATE]: mutate,
  [MUTATE_MULTIPLE]: mutateMultiple,
  [MUTATE_ARRAY_INDEX]: mutateArrayIndex
};
